"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _sendToDatadog = require("./sendToDatadog");
Object.keys(_sendToDatadog).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _sendToDatadog[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _sendToDatadog[key];
    }
  });
});
var _logAppEntry = require("./logAppEntry");
Object.keys(_logAppEntry).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logAppEntry[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logAppEntry[key];
    }
  });
});
var _customDatadogLogs = require("./customDatadogLogs");
Object.keys(_customDatadogLogs).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _customDatadogLogs[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _customDatadogLogs[key];
    }
  });
});
var _logProgramChange = require("./logProgramChange");
Object.keys(_logProgramChange).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logProgramChange[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logProgramChange[key];
    }
  });
});
var _logEventLoopLag = require("./logEventLoopLag");
Object.keys(_logEventLoopLag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _logEventLoopLag[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _logEventLoopLag[key];
    }
  });
});
var _initRum = require("./initRum");
Object.keys(_initRum).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _initRum[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _initRum[key];
    }
  });
});
var _heartbeat = require("./heartbeat");
Object.keys(_heartbeat).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _heartbeat[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _heartbeat[key];
    }
  });
});